// extracted by mini-css-extract-plugin
export default {"wrapper":"OQyUbkLMWcJwKVDCEpfF","linkWrapper":"N7OaMkBtzA5jWD4Gxw8C","link":"y3YgMEyO_9JUJUzoBgkL"};